import { centsToDollarsDisplay } from "../../displayFormatters"
import Logger from "../../../logging/logger"
import { AcceleratedAchRate, TenantMerchantStatusData } from "../../../domain/invoicing/rainforest"

export const shouldShowNextDayAchSettings = (data: TenantMerchantStatusData | undefined): data is TenantMerchantStatusData => {
  return data !== undefined && data.nextDayAchFeatureEnabled && data.merchantStatus === 'ACTIVE'
}

export const isNextDayAchOn = (data: TenantMerchantStatusData): boolean => {
  return data.acceleratedAchMode === 'ENABLED'
}

export const isNextDayAchLocked = (data: TenantMerchantStatusData): boolean => {
  return data.acceleratedAchMode === 'DISABLED_BY_RAINFOREST'
}

export const nextDayAchPricingText = (rate: AcceleratedAchRate | null): string => {
  if (!rate) {
    Logger.logError(new Error('Next-Day ACH settings rendered without an accelerated ACH rate'))
    return ''
  }
  const fee = rate.fixedFeeCents > 0 ? ` + ${centsToDollarsDisplay(rate.fixedFeeCents)}` : ''
  return `Pricing is ${rate.percentage}%${fee} per ACH transaction on next-day volume.`
}
